import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DefaultButton from 'components/Utils/NewDefaultButton';
import MenuItem from '@material-ui/core/MenuItem';
import DefaultTextField from 'components/Utils/DefaultTextField';
import UploadFile from 'components/Utils/UploadFile';
import DefaultSelectField from 'components/Utils/DefaultSelectField';
import NewDocumentTemplateCategory from 'components/HealthRecords/Documents/NewDocumentTemplateCategory';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { useAppSelector } from 'careand-redux/store';
import { api } from 'careand-redux/api/ApiThunks';

const NewDocumentTemplate = ({ template, onClose }) => {
  const dispatch = useAppDispatch();

  const templateCategories = useAppSelector((state) => state.templates.templateCategories);

  const [file, setFile] = useState(false);
  const [saving, setSaving] = useState(false);
  const [categoryId, setCategoryId] = useState(template?.category_id || '');
  const [description, setDescription] = useState(template?.description || '');
  const [addDocumentTemplateCategory, setAddDocumentTemplateCategory] = useState(false);

  const submitDisabled = file === undefined || categoryId === '' || description === '';

  function onDrop(file) {
    setFile(file);
  }

  async function save() {
    setSaving(true);

    const result = await dispatch(
      api.Templates.addDocumentTemplate({
        file,
        categoryId,
        description,
        templateId: template?.id,
      }),
      {
        title: 'Document Template',
        successText: 'The template has been added successfully',
      },
    );

    setSaving(false);
    if (result) {
      onClose();
    }
  }

  if (addDocumentTemplateCategory)
    return <NewDocumentTemplateCategory onClose={() => setAddDocumentTemplateCategory(false)} />;

  return (
    <div className="modal add-template-modal">
      <div className="title">Add Document Template</div>
      <div className="content padded-box" style={{ height: 'auto' }}>
        {!template && (
          <>
            <DefaultSelectField
              key="category_id"
              name="category_id"
              label="Category"
              style={{ width: '80%' }}
              value={categoryId}
              onChange={(event) => setCategoryId(event.target.value)}
              inputElements={templateCategories.map((category) => (
                <MenuItem value={category.id} key={'select-' + category.id}>
                  {category.name}
                </MenuItem>
              ))}
            />
            <div
              style={{
                position: 'relative',
                display: 'inline-block',
                width: '20%',
                height: '100%',
              }}
            >
              <DefaultButton
                name="+"
                style={{
                  width: '40px',
                  minWidth: '40px',
                  position: 'absolute',
                  right: '0',
                }}
                onClick={() => setAddDocumentTemplateCategory(true)}
              />
            </div>
            <DefaultTextField
              name="description"
              value={description}
              onChange={(event) => setDescription(event.target.value)}
              label="Description"
            />
          </>
        )}
        <UploadFile accept="application/pdf" title="Upload PDF" hideButton={true} onDrop={onDrop} />
      </div>
      <div
        className="buttons"
        style={{
          background: 'white',
          width: '100%',
          padding: '20px',
          boxSizing: 'border-box',
          textAlign: 'center',
        }}
      >
        <DefaultButton
          name="Cancel"
          onClick={onClose}
          style={{ marginRight: '10px' }}
          disabled={saving}
        />
        <DefaultButton
          name="Save"
          onClick={save}
          loading={saving}
          style={{ marginLeft: '10px' }}
          disabled={submitDisabled}
        />
      </div>
    </div>
  );
};

NewDocumentTemplate.propTypes = {
  onClose: PropTypes.func.isRequired,
  templateId: PropTypes.string,
};

export default NewDocumentTemplate;
